module.exports = {
    methods: {
        asset: window.Vapor.asset,
        isEmpty: function (obj) {
            return Object.keys(obj).length === 0;
        },
    },
};
